import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRegister } from 'modules/api';
import {
  LegalEntityUser,
  PhysicalEntityUser,
} from '../components/common/RegistrationUser';

export const registerPrivateIndividual = createAsyncThunk(
  'register/registerPrivateIndividual',
  async (user: PhysicalEntityUser, { rejectWithValue }) => {
    try {
      const response = await ApiRegister.registerPrivateIndividual(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const registerLegalEntity = createAsyncThunk(
  'register/registerLegalEntity',
  async (user: LegalEntityUser, { rejectWithValue }) => {
    try {
      const response = await ApiRegister.registerLegalEntity(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
